/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftsAvailableSlotsQueryResponse, GetApiBarberShiftsAvailableSlotsQueryParams, GetApiBarberShiftsAvailableSlots400, GetApiBarberShiftsAvailableSlots401, GetApiBarberShiftsAvailableSlots403, GetApiBarberShiftsAvailableSlots404, GetApiBarberShiftsAvailableSlots500 } from "../entities/GetApiBarberShiftsAvailableSlots";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBarberShiftsAvailableSlots } from "../api/getApiBarberShiftsAvailableSlots";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBarberShiftsAvailableSlotsQueryKey = (params: GetApiBarberShiftsAvailableSlotsQueryParams) => [{ url: '/api/barber/shifts/available-slots' }, ...(params ? [params] : [])] as const

export type GetApiBarberShiftsAvailableSlotsQueryKey = ReturnType<typeof getApiBarberShiftsAvailableSlotsQueryKey>

export function getApiBarberShiftsAvailableSlotsQueryOptions(params: GetApiBarberShiftsAvailableSlotsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBarberShiftsAvailableSlotsQueryKey(params)
        return queryOptions<GetApiBarberShiftsAvailableSlotsQueryResponse, ResponseErrorConfig<GetApiBarberShiftsAvailableSlots400 | GetApiBarberShiftsAvailableSlots401 | GetApiBarberShiftsAvailableSlots403 | GetApiBarberShiftsAvailableSlots404 | GetApiBarberShiftsAvailableSlots500>, GetApiBarberShiftsAvailableSlotsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBarberShiftsAvailableSlots(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить доступные слоты и занятые интервалы кресел для бронирования смены за период
 * @summary Доступные слоты смен
 * {@link /api/barber/shifts/available-slots}
 */
export function useGetApiBarberShiftsAvailableSlots<TData = GetApiBarberShiftsAvailableSlotsQueryResponse, TQueryData = GetApiBarberShiftsAvailableSlotsQueryResponse, TQueryKey extends QueryKey = GetApiBarberShiftsAvailableSlotsQueryKey>(params: GetApiBarberShiftsAvailableSlotsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBarberShiftsAvailableSlotsQueryResponse, ResponseErrorConfig<GetApiBarberShiftsAvailableSlots400 | GetApiBarberShiftsAvailableSlots401 | GetApiBarberShiftsAvailableSlots403 | GetApiBarberShiftsAvailableSlots404 | GetApiBarberShiftsAvailableSlots500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBarberShiftsAvailableSlotsQueryKey(params)
         

         const query = useQuery({
          ...getApiBarberShiftsAvailableSlotsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiBarberShiftsAvailableSlots400 | GetApiBarberShiftsAvailableSlots401 | GetApiBarberShiftsAvailableSlots403 | GetApiBarberShiftsAvailableSlots404 | GetApiBarberShiftsAvailableSlots500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}